import { render, staticRenderFns } from "./ShipStuation.vue?vue&type=template&id=6993b4a7&"
import script from "./ShipStuation.vue?vue&type=script&lang=js&"
export * from "./ShipStuation.vue?vue&type=script&lang=js&"
import style0 from "./ShipStuation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports